import { demostrationServiceMachine } from './SampleService';

export default { demostrationServiceMachine };
